
/* injects from baggage-loader */

'use strict';
/**
 * Constants to use in the application depending of the environment used.
 *
 * @export
 * @param {shared.module} app
 */
export default function (app) {

	/**
	 * Constants definition for the navigation routes for each profiles in the applications.
	 */
	const userAccessConstant = {
		ADMIN: {
			MENUS: [
				'01', '07', '02', '05', '06'
			],
			RESOURCES: [
				'RP-01'
			],
			SUBMENUS: [
				'0706', '0707'			]
		},
		CASHIER: {
			MENUS: [
				'07', '02', '05'
			],
			RESOURCES: [
				'AS-01', 'AS-02', 'AS-03'
				, 'IS-01', 'IS-02'
				, 'CFD-02','RS-01'
			],
			SUBMENUS: [
				'0702', '0709', '0705', '0703',
				'0704', '0708'
			]
		},
		COMPANY: {
			MENUS: [
				'07', '02', '05'
			],
			RESOURCES: [
				'AS-01', 'AS-03'
				, 'CFD-02', 'RP-01'
			],
			SUBMENUS: [
				'0702', '0709', '0705', '0703', '0710'
			]
		},
	}

	app.constant('userAccessConstant', userAccessConstant);
}



// WEBPACK FOOTER //
// ./src/app/core/constants/userAccess.constants.js